import classNames from "classnames";
import React, {ReactNode} from "react";


import {ImportMode, supportedDocumentTypes, supportedImageTypes} from "../../../actions/import/importFile";


import {useDropArea} from "../../hooks/useDropArea";
import {UploadFileIcon} from "../icons/UploadFileIcon";


export interface DropBoxProps {
    className?: string; // 'document' | 'image'
    mode?: ImportMode;
    addFiles: (file: File[] | FileList) => void;
    onClick: () => void;
    children?: ReactNode;
    hint?: ReactNode;
    subHint?: ReactNode;
}

export const DropBox = (
    {
        className,
        mode,
        addFiles,
        onClick,
        hint,
        subHint,
    }: DropBoxProps
) => {
    const selectedSupportedTypes =
        mode === 'image' ? supportedImageTypes : supportedDocumentTypes;
    const {
        isDragOver,
        onDragOver,
        onDragEnter,
        onDragLeave,
        onDrop
    } = useDropArea(addFiles, selectedSupportedTypes);

    return (
        <div
            className={classNames({
                "DragDropUpload__area": true,
                "DragDropUpload__area--dragover": isDragOver
            })}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDragOver={onDragOver}
            onDrop={onDrop}
            onClick={onClick}
        >
            <div className="DragDropUpload__content">
                <UploadFileIcon size={24}/>
                <p className="DragDropUpload__hint body-large">
                    {hint}
                </p>
                {subHint && (
                    <p className="DragDropUpload__subhint body-medium">
                        {subHint}
                    </p>
                )}
            </div>
        </div>
    );
}
